// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --modal-duration: 0.1s;
  }
  
  .modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;    
    list-style: none;
    
  }
  
  .modalcontent {
    position: relative;
    margin: 10% auto;
    text-align: center;
    width: 650px;
    /* height: 530px; */
    background-color: white;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.17);
    animation-name: modalopen;
    animation-duration: var(--modal-duration);
    border-radius: 10px;     
    padding-bottom: 1rem; 
  }
  
  .modalbody ul .memo {
    width : 500px;
    margin-top : 7px;
 }

 .modalbody ul .memo #input-memo{
    width : 400px;
    height : 40px;
 }
  
 @media (max-width : 1024px)  {
    #insert-modal{
      top : 20%;
    }
    .modalcontent {
      width : 300px;
      height: 500px;    
      overflow: auto;
    }
    .modalheader {
      margin-left : 25px;
    } 
    .modalbody ul .memo {
      width : 250px;
      margin-top : 7px;
   }
    .modalbody ul .memo #input-memo{
      width : 200px;
      height : 60px;  
   }   
  }
  
  .modalheader img {
    margin-top: 50px;
    width: 150px;
    height: 150px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .modalbody {
    display : flex;
    flex-wrap : wrap;
    padding-top : 40px;
  }
  .modalbody ul {
    margin-top: 50px;
    display : contents;
  }
  
  .modalbody ul li {
    width: 250px;
    margin: 0 auto;
    text-align: left;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    list-style: none;
    
  }

  .front {
    color: #b52929;
    font-weight: 300;
    font-size: 14px;
    height : 25px;  
    float : left  
  }
  .back {
    font-size: 14px;
    font-weight: 300;
    float: right;
    height : 25px
  }


  
  .modalfooter button {
    margin-top: 20px;
    width: 130px;
    height: 40px;
    border-radius: 5px;
  }
  .out_btn {
    margin-right: 10px;
    background-color: #ffcbcf;
  }
  .out_btn:hover {
    background-color: #b52929;
    transition: 0.3s all ease;
    color: white;
  }
  .yet_btn:hover {
    background-color: rgb(126, 126, 126);
    color: white;
    transition: 0.3s all ease;
  }
  


  @keyframes modalopen {
    from {
     
      opacity: 0;
    }
    to {
      
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/modal/AssetInsertModal.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,4EAA4E;IAC5E,yBAAyB;IACzB,yCAAyC;IACzC,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,gBAAgB;CACnB;;CAEA;IACG,aAAa;IACb,aAAa;CAChB;;CAEA;IACG;MACE,SAAS;IACX;IACA;MACE,aAAa;MACb,aAAa;MACb,cAAc;IAChB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,aAAa;MACb,gBAAgB;GACnB;IACC;MACE,aAAa;MACb,aAAa;GAChB;EACD;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;;EAElB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ;EACF;;;;EAIA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,yBAAyB;EAC3B;;;;EAIA;IACE;;MAEE,UAAU;IACZ;IACA;;MAEE,UAAU;IACZ;EACF","sourcesContent":[":root {\n    --modal-duration: 0.1s;\n  }\n  \n  .modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;    \n    list-style: none;\n    \n  }\n  \n  .modalcontent {\n    position: relative;\n    margin: 10% auto;\n    text-align: center;\n    width: 650px;\n    /* height: 530px; */\n    background-color: white;\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.17);\n    animation-name: modalopen;\n    animation-duration: var(--modal-duration);\n    border-radius: 10px;     \n    padding-bottom: 1rem; \n  }\n  \n  .modalbody ul .memo {\n    width : 500px;\n    margin-top : 7px;\n }\n\n .modalbody ul .memo #input-memo{\n    width : 400px;\n    height : 40px;\n }\n  \n @media (max-width : 1024px)  {\n    #insert-modal{\n      top : 20%;\n    }\n    .modalcontent {\n      width : 300px;\n      height: 500px;    \n      overflow: auto;\n    }\n    .modalheader {\n      margin-left : 25px;\n    } \n    .modalbody ul .memo {\n      width : 250px;\n      margin-top : 7px;\n   }\n    .modalbody ul .memo #input-memo{\n      width : 200px;\n      height : 60px;  \n   }   \n  }\n  \n  .modalheader img {\n    margin-top: 50px;\n    width: 150px;\n    height: 150px;\n    border-radius: 5px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n  }\n\n  .modalbody {\n    display : flex;\n    flex-wrap : wrap;\n    padding-top : 40px;\n  }\n  .modalbody ul {\n    margin-top: 50px;\n    display : contents;\n  }\n  \n  .modalbody ul li {\n    width: 250px;\n    margin: 0 auto;\n    text-align: left;\n    padding-bottom: 5px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    list-style: none;\n    \n  }\n\n  .front {\n    color: #b52929;\n    font-weight: 300;\n    font-size: 14px;\n    height : 25px;  \n    float : left  \n  }\n  .back {\n    font-size: 14px;\n    font-weight: 300;\n    float: right;\n    height : 25px\n  }\n\n\n  \n  .modalfooter button {\n    margin-top: 20px;\n    width: 130px;\n    height: 40px;\n    border-radius: 5px;\n  }\n  .out_btn {\n    margin-right: 10px;\n    background-color: #ffcbcf;\n  }\n  .out_btn:hover {\n    background-color: #b52929;\n    transition: 0.3s all ease;\n    color: white;\n  }\n  .yet_btn:hover {\n    background-color: rgb(126, 126, 126);\n    color: white;\n    transition: 0.3s all ease;\n  }\n  \n\n\n  @keyframes modalopen {\n    from {\n     \n      opacity: 0;\n    }\n    to {\n      \n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
